module.exports = __webpack_public_path__ + "img/fafangwancheng.4d9fa2e5.svg";